<template>
  <div style="padding: 15px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="140px"
    >
      <el-form-item
        label="违章时间"
        prop="violationTime"
        required
      >
        <el-date-picker
          v-model="form.violationTime"
          type="date"
          placeholder="请输入违章时间"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item
        label="违章地址"
        prop="violationPlace"
      >
        <el-input
          v-model="form.violationPlace"
          placeholder="请输入违章地址"
        />
      </el-form-item>

      <el-form-item
        label="违章行为"
        prop="violationProject"
      >
        <el-input
          v-model="form.violationProject"
          placeholder="请输入违章行为"
        />
      </el-form-item>
      <el-form-item
        label="违章记分"
        prop="deductPoints"
      >
        <el-input
          v-model.number="form.deductPoints"
          placeholder="请输入违章记分"
          @input="(value)=>formFormatter.ishundredInteger(value,oldValue,form,'deductPoints')"
        />
      </el-form-item>
      <el-form-item
        label="罚款金额"
        prop="penaltyAmount"
      >
        <el-input
          v-model="form.penaltyAmount"
          placeholder="请输入罚款金额"
          @input="(value)=>formFormatter.isFloor2(value,oldValue,form,'penaltyAmount')"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="funcCancel">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="funcSubmit"
        >
          确 定
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { vehicleViolationAdd } from "@/api/vehicleService";
import { mayDecimal } from "@/utils/validate4Form.js";
export default {
  name: "VehicleInsuranceAdd",
  props: {
    vehicleCode: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      tempData: null,
      errorMessage: "",
	  options:[],
      form: {
        vehicleCode:'',   // 驾驶车辆编码
		    violationTime:'',  // 违章日期
		    violationPlace:'',  // 	违章地点
		    violationProject:'',  // 违章项目
		    deductPoints:'',  // 扣分
	    	penaltyAmount:''  // 罚款金额
      },
      rules: {
        violationTime: [
          { required: true, message: "请输入违章时间", trigger: "blur" }
        ],
		violationPlace: [
      { required: true, message: "请输入违章地址", trigger: "blur" },
      {  max: 256, message: '最大长度256字符' },
		],
		violationProject: [
      { required: true, message: "请输入违章行为", trigger: "blur" },
       {  max: 256, message: '最大长度256字符' },
		],
		deductPoints: [
      { required: true, message: "请输入记分", trigger: "blur" }
		],
		penaltyAmount: [
      { required: true, message: "请输入罚款金额", trigger: "blur" },
      { validator:mayDecimal }
		]
      }
    };
  },
  computed: {

  },
  methods: {
	  getCode(code){
      this.$refs.form.resetFields()
		  if (code) this.form.vehicleCode = code
    },
    changeDiscountRate(e) {
      if (e < 0 || e > 100) {
        this.$message({ message: "只能输入0-100的数字", type: "warning" });
      } 
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          vehicleViolationAdd(this.form)
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("hideModel", this.form.vehicleCode);
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("hideModel",'');
    }
  }
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  width: 100%;
}
.el-autocomplete {
  width: 100%;
}
</style>
